import { enum_ } from "valibot"

export enum HorizontalOrVertical {
  Horizontal = 0,
  Vertical = 1,
}

export const HorizontalOrVerticalSchema = enum_(HorizontalOrVertical, 'Invalid Orientation')
